<template>
  <form-select
    class="version-select-en"
    v-model="val"
    :options="options"
    v-on="$listeners"
  ></form-select>
</template>
<script>
export default {
  name: 'version-select-en',
  props: {
    version: Array,
    value: String,
    queryObj: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  model: {
    prop: 'value',
    event: 'setval'
  },
  computed: {
    val: {
      get() {
        return this.value
      },
      set(newVal) {
        this.$emit('setval', newVal)
      }
    }
  },
  data() {
    return {
      options: []
    }
  },
  watch: {
    queryObj(newVal) {
      this.val = null
      this.options = []
      let paramObj = Object.assign({ lang: 'EN' }, { ...newVal })
      this.$post('view/getVersion', paramObj)
        .then((resp) => {
          if (resp.data.code == 0 && resp.data.data.length > 0) {
            let versionOptions = []
            for (let item of resp.data.data) {
              versionOptions.push({
                label: 'V' + item.version,
                value: item.version
              })
            }
            if (versionOptions.length > 0) {
              this.options = versionOptions
              this.val = versionOptions[0].value
            }
            this.$nextTick(() => {
              this.$emit('change', this.val)
            })
          } else {
            this.$message('获取产品失败')
          }
        })
        .catch((error) => {
          this.$message('获取产品发生错误=>' + error)
        })
    }
  }
}
</script>
<style lang="less">
.version-select-en {
  width: 100px;
}
</style>
